import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdminService, ApiService, AuthService, ModalService, SessionService, MetadataService, ConditionService, DialogService, FieldService } from '../../../services';
import { UscCampaignService } from '../../../services/usc-campaign/usc-campaign.service';
import { DialogComponent } from '../../common/dialog/dialog.component';
import { ModalComponent } from '../../modal/modal.component';
import { UscCamaignComponent } from '../usc-campaign.component';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'sn-usci-home',
	templateUrl: './usci-home.component.html',
	styleUrls: ['./usci-home.component.css']
})
export class UsciHomeComponent extends UscCamaignComponent {

	constructor(
		private router: Router,
		public dialogService: DialogService,
		public modalService: ModalService,
		public adminService: AdminService,
		public metadataService: MetadataService,
		public authService: AuthService,
		public apiService: ApiService,
		public sessionService: SessionService,
		public conditionService: ConditionService,
		public uscCampaignService: UscCampaignService,
		public fieldService: FieldService,
		public ngbModal: NgbModal
	) {
		super(adminService, metadataService, authService, apiService, sessionService, uscCampaignService);
  	}

	ngOnInit() {
		var dlg = this.dialogService.showLoadingDlg(DialogComponent, {msg: "Initialize..."});
		this.loadMetaData().subscribe(
			data => {
                this.sessionService.log("Default Meta Data Loaded", new Date());
				dlg.dismiss();
			},
            err => { this.sessionService.log(err) }
		)
	}

	//Change Store Hours, Change Store BE, Store Closure, Store Opening, Store Relocation and Store Transition.
	storeUpdateRequest() {
		this.openModalByView(this.uscCampaignService.view_usci_store_update_request);
	}

	newCampaignRequest() {
		this.openModalByView(this.uscCampaignService.view_usci_new_campaign_request);
	}

	//BE, OBTM, Promotion, Sentiment, Targeted and Other
	openModalByView(view) {
		this.modalService.openContent(
			ModalComponent,
			{ view: view, data: { view_ID: 0 } },
			{ backdrop: 'static', keyboard: false }
		).result.then(
			(result) => {
				var dl_ID, dl_cfd_sms, dl_cfd_ccnl, dl_cfd_toc, dl_cfd_tsur, dl_cfd_rtcsh;
				for (var i = 0; i < result.data.length; i++) {
					if (result.data[i].key == "dl_ID") dl_ID = result.data[i].value;
					if (result.data[i].key == "dl_cfd_sms") dl_cfd_sms = result.data[i].value;
					if (result.data[i].key == "dl_cfd_ccnl") dl_cfd_ccnl = result.data[i].value;
					if (result.data[i].key == "dl_cfd_toc") dl_cfd_toc = result.data[i].value;
					if (result.data[i].key == "dl_cfd_tsur") dl_cfd_tsur = result.data[i].value;
					if (result.data[i].key == "dl_cfd_rtcsh") dl_cfd_rtcsh = result.data[i].value;
				}
				var msgList = [];
				msgList.push("Your Campaign Request has been submitted – ID: " + dl_ID + ".");
				msgList.push("");
				msgList.push("Please retain this Request ID in the event that a change is required to this campaign request.");

				if (dl_cfd_sms == 'Yes') {
					msgList.push("");
					msgList.push("The Mass SMS request was sent to the vendor.");
				} 
				if (dl_cfd_ccnl == "Yes") {
					msgList.push("");
					msgList.push("The data for the outbound campaign has been requested.");
				} 
				if (dl_cfd_tsur == 'Store Relocation' || dl_cfd_tsur == 'Store Ownership Transition') {
					if (dl_cfd_rtcsh == "Yes") {
						msgList.push("");
						msgList.push("LAVI has been notified of the store hour changes.");
					}
				}

				this.modalService.openContent(
					DialogComponent,
					{ dlgType: this.dialogService.dlg_type_confirmation, dlg_config: { msgList: msgList }},
					{ backdrop: 'static', keyboard: false }
				).result.then(
					(result) => { },
					(reason) => { }
				);        
			}, (reason) => {
				this.sessionService.log('New Campaign Request Form Closed');
		})  
	}

	changeRequest(request_type, id) {
		this.modalService.openContent(
			ModalComponent,
			{ view: this.uscCampaignService.view_usci_change_request, data: { view_ID: parseInt(id) } },
			{ backdrop: 'static', keyboard: false }
		).result.then(
			(result) => {
				var msgList = [];
				var bPromptForRequestID = false;
				if (result.event == "item_not_found") {
					msgList.push("Change Request not found, please verify your request ID.");
					bPromptForRequestID = true;
				} else {
					msgList.push("Your Change Request (ID:" + id + ") has been submitted.");
				}  
				this.modalService.openContent(
					DialogComponent,
					{ dlgType: this.dialogService.dlg_type_confirmation, dlg_config: { msgList: msgList }},
					{ backdrop: 'static', keyboard: false }
				).result.then(
					(result) => { if (bPromptForRequestID) this.promptForRequestID(request_type); },
					(reason) => { }
				);

			}, (reason) => {
				this.sessionService.log('Change Campaign Request Form Closed');
		})  
	}

	approveRequest(request_type, id) {
		this.modalService.openContent(
			ModalComponent,
			{ view: this.uscCampaignService.view_usci_store_update_request_approval, data: { view_ID: parseInt(id) } },
			{ backdrop: 'static', keyboard: false }
		).result.then(
			(result) => {
				var msgList = [];
				var bPromptForRequestID = false;
				if (result.event == "item_not_found") {
					msgList.push("Change Request not found, please verify your request ID.");
					bPromptForRequestID = true;
				} else {
					msgList.push("Your Request Approval (ID:" + id + ") has been submitted.");
				}  
				this.modalService.openContent(
					DialogComponent,
					{ dlgType: this.dialogService.dlg_type_confirmation, dlg_config: { msgList: msgList }},
					{ backdrop: 'static', keyboard: false }
				).result.then(
					(result) => { if (bPromptForRequestID) this.promptForRequestID(request_type); },
					(reason) => { }
				);

			}, (reason) => {
				this.sessionService.log('Request Approval Form Closed');
		})  
	}
	
	promptForRequestID(request_type) {
		var msgList = [];
		var msg = "Please enter a Campaign Request ID you wish to change: ";
		if (request_type == "store_update") msg = "Please enter a Store Update Request ID you wish to change: ";
		msgList.push(msg);
		var input = { type: "T", class: 'col-md-12 col-lg-12 text-center sn-i-center' };
		var buttons = [];
		var btn_confirm = { type: 'confirm', label: 'Submit', class: 'col-md-6 col-lg-6 text-center', event: 'confirm-campaign-ID' };
		var btn_cancel = { type: 'cancel', label: 'Cancel', class: 'col-md-6 col-lg-6 text-center', event: 'cancel' };
		buttons.push(btn_confirm);
		buttons.push(btn_cancel);
		// prompt for request item ID
		this.modalService.openContent(
			DialogComponent,
			{ dlgType: this.dialogService.dlg_type_prompt, dlg_config: { msgList: msgList, input: input, buttons: buttons }},
			{ backdrop: 'static', keyboard: false }
		).result.then(
			(result) => {
				var response = result.response;
				if (parseInt(result.response.value) > 0) {
					// try to get the request item first to determine the next step
					this.apiService.getViewItem(this.uscCampaignService.view_usci_change_request, response.value).subscribe(
						result => {
							if (result && result.item) {
								// if item is Campaign Request, changeRequest
								if (this.isCampaignRequest(result.item, request_type)) {
									this.changeRequest(request_type, response.value);
								} else if (this.isStoreUpdateRequest(result.item, request_type)) {
								// if item is Campaign Request and still under requested stage and current user is an approver, approveRequest
								if (result.item.dl_stage == 'Requested' && this.isMarketingRequestApprover()) {
										this.approveRequest(request_type, response.value);
									} 
									// else just changeRequest
									else {
										this.changeRequest(request_type, response.value);
									}
								} else {
									this.processInvalidRequest(request_type);
								}
							}	
						}
					);
				} else {
					this.processInvalidRequest(request_type);
				}
			},
			(reason) => { }
		);
	}

	isCampaignRequest(item, type):boolean { return item.dl_cfd_toc && type == 'campaign'; }
	isStoreUpdateRequest(item, type):boolean { return item.dl_cfd_tsur && type == 'store_update'; }
	isMarketingRequestApprover() {
		var auth_user = this.authService.getAuth();
		return (this.fieldService.getItemCustomFieldValue(auth_user, 'is Marketing Request Approver') == 'Yes');
	}

	processInvalidRequest(request_type) {
		var msgList = ["Invalid request ID, please try again."];
		this.modalService.openContent(
			DialogComponent,
			{ dlgType: this.dialogService.dlg_type_confirmation, dlg_config: { msgList: msgList }},
			{ backdrop: 'static', keyboard: false }
		).result.then(
			(result) => { this.promptForRequestID(request_type); },
			(reason) => { }
		);
	}

	isButtonAllowed(btn_type) {
		var user = this.authService.getActive();
		return this.fieldService.getItemCustomFieldValue(user, "Allow " + btn_type) != "No";
	}

	logOff() {
		this.authService.logoff();
	} 
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-campaign/usci-home/usci-home.component.ts